import InfoIcon from '@mui/icons-material/Info';
import { brand } from '@/lib/theme/tokens/palettes';
import Box from '@/components/Box';

const Information = ({ children, maxWidth = '400px' }) => {
  return (
    <Box
      sx={{
        px: 1,
        pb: 2,
        maxWidth,
      }}
    >
      <Box sx={{ pt: 1, textAlign: 'left' }}>
        <InfoIcon
          sx={{
            color: brand.yellow.main,
          }}
        />
      </Box>
      {children}
    </Box>
  );
};

export default Information;
